/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Ai_Processing_LabelInputs */

const en_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand that Alchema uses AI/LLM models to analyze, extract, and optimize my candidate and job-application data.`)
};

const de_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich verstehe, dass Alchema KI/LLM-Modelle nutzt, um meine Kandidaten- und Bewerbungsdaten zu analysieren, zu extrahieren und zu optimieren.`)
};

const fr_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je comprends qu'Alchema utilise des modeles IA/LLM pour analyser, extraire et optimiser mes donnees de candidature et de demande d'emploi.`)
};

const es_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entiendo que Alchema utiliza modelos de IA/LLM para analizar, extraer y optimizar mis datos de candidatura y solicitud de empleo.`)
};

const it_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capisco che Alchema usa modelli IA/LLM per analizzare, estrarre e ottimizzare i miei dati di candidato e candidatura.`)
};

const nl_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik begrijp dat Alchema AI/LLM-modellen gebruikt om mijn kandidaat- en sollicitatiegegevens te analyseren, extraheren en optimaliseren.`)
};

const pl_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozumiem, ze Alchema uzywa modeli AI/LLM do analizy, ekstrakcji i optymalizacji moich danych kandydata i aplikacji o prace.`)
};

const fi_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ymmarran, etta Alchema kayttaa AI/LLM-malleja hakija- ja tyohakemustietojeni analysointiin, poimintaan ja optimointiin.`)
};

const da_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg forstaar, at Alchema bruger AI/LLM-modeller til at analysere, udtraekke og optimere mine kandidat- og jobansoegningsdata.`)
};

const sv_consent_ai_processing_label = /** @type {(inputs: Consent_Ai_Processing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag forstar att Alchema anvander AI/LLM-modeller for att analysera, extrahera och optimera mina kandidat- och jobbansokningsdata.`)
};

/**
* | output |
* | --- |
* | "I understand that Alchema uses AI/LLM models to analyze, extract, and optimize my candidate and job-application data." |
*
* @param {Consent_Ai_Processing_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_ai_processing_label = /** @type {((inputs?: Consent_Ai_Processing_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Ai_Processing_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_ai_processing_label(inputs)
	if (locale === "fr") return fr_consent_ai_processing_label(inputs)
	if (locale === "es") return es_consent_ai_processing_label(inputs)
	if (locale === "it") return it_consent_ai_processing_label(inputs)
	if (locale === "nl") return nl_consent_ai_processing_label(inputs)
	if (locale === "pl") return pl_consent_ai_processing_label(inputs)
	if (locale === "fi") return fi_consent_ai_processing_label(inputs)
	if (locale === "da") return da_consent_ai_processing_label(inputs)
	if (locale === "sv") return sv_consent_ai_processing_label(inputs)
	return en_consent_ai_processing_label(inputs)
});